module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306237.2f8c3be5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306237.pdf
// module id = 823
// module chunks = 0